import { PermissionT } from "../types";

export const enterprisesSuperAdmin = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprises_super_admin");
  return !!p;
};
export default enterprisesSuperAdmin;
